import type { ICustomControlRequestReadProps } from '../../../interfaces/customControlRequestReadProps';
import { translateKey } from '../../../../../../translate';
import { UserTextParagraph } from '../../../../../elements/common';
import { FormLabel } from '../../../../../elements/forms/FormLabel';
import { HorizontalFormGroupRead } from '../../../../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../../../../elements/forms/InputContainer';
import { RequestThumbnails } from '../../../utils/v1/RequestThumbnails';

export function PilotExaminationV1RequestSummary(props: ICustomControlRequestReadProps) {
    return (
        <>
            {props.request.customControlData.indicatie && (
                <HorizontalFormGroupRead>
                    <FormLabel>{translateKey('request.indication')}</FormLabel>
                    <InputContainer>
                        <UserTextParagraph>{props.request.customControlData.indicatie}</UserTextParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}

            <RequestThumbnails {...props} />
        </>
    );
}
